<template>
  <div class="new-container profit-container" id="calc_container">
    <div class="container">
      <Header/>
      <div class="main">
        <div class="list-container">
          <el-form class="submit_form" ref="submitFormRef" :rules="submitFormRules" :model="submitForm"
                   label-position="top">
            <div class="content-container">
              <div class="left-container">
                <div class="title">Belt Length Calculator</div>
                <div class="subtitle">Start by entering some numbers</div>
                <div class="content">
                  <p>With Omni Esk8 Belt Length Calculator, you can determine the length<br/> of any belt. Simply start
                    by
                    entering some numbers.</p>

                  <p>Belt Length - Two Pulley System</p>
                  <ul>
                    <li>Driver Gear Teeth: the teeth of wheel pulley(Large Pulley)</li>
                    <li> Driven Gear Teeth: the teeth of motor shaft(Small Pulley)</li>
                  </ul>
                  <p style="">For unknown center diameter, please directly measure it with tools or<br/> go through the
                    calculator below. ↓↓↓</p>
                </div>
              </div>
              <div class="right-container">
                <div class="calc-form-container">
                  <div class="left-item">
                    <el-form-item prop="tooth_profile" label="Teeth Pitch" class="item-title">
                      <el-select v-model="submitForm.tooth_profile" class="additionOthers dashed"
                                 placeholder="">
                        <el-option v-for="item in tooth_profile_options" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="central_moment" label="Center Distance(mm)" class="item-title">
                      <p>
                        <el-input v-model="submitForm.central_moment" class="additionOthers dashed" type="number"
                                  placeholder=""></el-input>
                      </p>
                    </el-form-item>
                  </div>
                  <div class="center-item">
                    <img src="@/assets/images/esk/belt.png" alt="">
                  </div>
                  <div class="right-item">
                    <el-form-item prop="driving_gear" label="Driver Gear Teeth" class="item-title">
                      <el-input v-model="submitForm.driving_gear" type="number" class="additionOthers dashed"
                                placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="passive_gear" label="Driven Gear Teeth" class="item-title">
                      <el-input v-model="submitForm.passive_gear" type="number" class="additionOthers dashed"
                                placeholder=""></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item prop="result" label="" class="item-title">
                  <p>
                    <el-input v-model="result" disabled class="additionOthers"
                              placeholder=""></el-input>
                  </p>
                </el-form-item>
                <el-form-item prop="show_result" label="" class="item-title recommend-belt">
                  <p>
                    <el-input v-model="show_result" disabled class="additionOthers show-result"
                              placeholder=""></el-input>
                  </p>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <div class="main">
        <div class="list-container">
          <el-form class="submit_form" ref="submitFormRef" :rules="submitForm2Rules" :model="submitForm2"
                   label-position="top">
            <div class="content-container content-container2">
              <div class="left-container">
                <div class="title">Pulley Center Distance</div>
                <div class="subtitle">Start by entering some numbers</div>
                <div class="content">
                  <p>You can also calculate the distance between the centers of two pulleys<br/> for a given belt length
                    in Omni Esk8 Calculator. Belt length, teeth pitch,<br/> and two pulley teeth are required in this
                    formula.</p>
                </div>
              </div>
              <div class="right-container">
                <div class="calc-form-container">
                  <div class="left-item">
                    <el-form-item prop="tooth_profile" label="Teeth Pitch" class="item-title">
                      <el-select v-model="submitForm2.tooth_profile" class="additionOthers dashed"
                                 placeholder="">
                        <el-option v-for="item in tooth_profile_options" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item prop="belt_length" label="Belt length(mm)" class="item-title">
                      <p>
                        <el-input v-model="submitForm2.belt_length" class="additionOthers dashed" type="number"
                                  placeholder=""></el-input>
                      </p>
                    </el-form-item>
                  </div>
                  <div class="center-item">
                    <img src="@/assets/images/esk/belt.png" alt="">
                  </div>
                  <div class="right-item">
                    <el-form-item prop="driving_gear" label="Driver Gear Teeth" class="item-title">
                      <el-input v-model="submitForm2.driving_gear" type="number" class="additionOthers dashed"
                                placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item prop="passive_gear" label="Driven Gear Teeth" class="item-title">
                      <el-input v-model="submitForm2.passive_gear" type="number" class="additionOthers dashed"
                                placeholder=""></el-input>
                    </el-form-item>
                  </div>
                </div>
                <el-form-item prop="result2" label="" class="item-title">
                  <p>
                    <el-input v-model="result2" disabled class="additionOthers"
                              placeholder=""></el-input>
                  </p>
                </el-form-item>
                <el-form-item prop="show_result2" label="" class="item-title recommend-belt">
                  <p>
                    <el-input v-model="show_result2" disabled class="additionOthers show-result"
                              placeholder=""></el-input>
                  </p>
                </el-form-item>
              </div>

            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.el-form {
  .el-form-item {
    margin-top: 30px;
    margin-bottom: 0;

    /deep/ .el-form-item__label {
      font-size: 15px;
      color: #fff;
      text-align: center;
    }

    /deep/ .el-input__inner {
      width: 100px;
      height: 50px;
      font-size: 30px;
      text-align: center;

    }

    /deep/ .el-select.dashed .el-input__inner, /deep/ .el-input.dashed .el-input__inner {
      color: var(--el-input__inner_color);
      background: var(--el-input__inner_background);
      border: 2px dashed #ccc;
      font-weight: bold;
    }

    /deep/ .el-input {
      width: auto;
    }

    /deep/ .el-form-item__content p {
      color: var(--el-form-item__content_color);
      text-align: center;
    }

    /deep/ .el-input.is-disabled .el-input__inner {
      color: var(--base_main_color);
      background: var(--el-input__inner_background);
      font-size: 35px;
      width: 350px;
      line-height: 50px;
      height: 50px;
      text-align: center;
      font-weight: bold;
      margin-top: 30px;
    }

    /deep/ .el-input.is-disabled.show-result .el-input__inner {
      height: 40px;
      font-size: 15px;
      margin-top: 0;
    }
  }

  .el-form-item.recommend-belt {
    margin-top: 10px;
  }

  .el-form-series .el-form-item__content {
    display: flex;
  }
}

.new-container {

  height: 100%;
  overflow: auto;

  .el-form-item__label {
    color: #fff;
  }

  .container {
    width: 100%;
    height: auto;
    margin: auto;
    overflow: hidden;
    background: #fff;

    .main {
      width: 100%;
      margin: auto;
      background: var(--main_background);

      .list-container {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 50px;
        margin: auto;

        .title {
          color: var(--title_color);
          font-size: var(--title_fontsize);
          font-weight: bold;
          line-height: 50px;
          text-align: left;
          margin-top: 30px;
          margin-bottom: 20px;
          position: relative;

          &:after {
            content: '';
            position: absolute;
            width: 200px;
            height: 3px;
            top: 60px;
            left: 0;
            background: #f1f8a0;
          }
        }

        .subtitle {
          color: #fff;
          font-size: 14px;
          text-align: left;
        }

        .content {
          color: #fff;
          font-size: 14px;
          width: 100%;
          margin: 80px auto 0;
        }

        .content p {
          line-height: 1.5;
          margin-top: 30px;
        }

        .el-checkbox.ng-untouched {
          margin-top: 5px;
          color: #aaa;
        }

        .form-series, .form-parallel {
          max-width: 80px;
        }

        .battery-container {
          display: flex;
          color: #fff;

          .left {
            width: 30%;
            padding-right: 30px;

            .left-title {
              font-size: 25px;
              font-weight: bold;
              margin-bottom: 10px;
            }

            .left-title2 {
              margin-top: 20px;
            }

            .row {
              display: flex;
              flex-wrap: wrap;
            }

            .input.row {
              justify-content: space-evenly;
              background-color: #444;
              margin: 1px;
              color: #aaa;
              padding-top: 10px;
              padding-bottom: 10px;

              label {
                display: flex;
                align-items: center;
              }
            }
          }

          .right {
            width: 70%;

            .right-container {
              display: flex;

              .right-item {
                &:nth-child(1) {
                  width: 35%;
                }

                &:nth-child(2) {
                  width: 35%;
                }

                &:nth-child(3) {
                  width: 30%;
                }

                margin-right: 20px;

                .header {
                  font-size: 20px;
                  margin-bottom: 15px;
                }

                .row {
                  display: flex;
                  flex-wrap: wrap;
                }

                .output.row {
                  justify-content: space-evenly;
                  align-items: center;
                  margin: 1px;
                  padding: 5px;
                  font-size: 13px;

                  .number-calc {
                    font-size: 1.3rem;
                    font-weight: 600;
                  }
                }
              }
            }
          }
        }

        .content-container {
          display: flex;
          width: 80%;
          margin: auto;
          justify-content: space-around;
        }

        .left-container {
          width: 50%;
          padding-left: 20px;
          box-shadow: 1px 1px 6px 1px #f1f8a0;
        }

        .right-container {
          width: 50%;
        }

        .content-container2 {
          width: 80%;

          .right-container {
            width: 50%;
          }

          .left-container {
            width: 50%;
          }

          .calc-form-container {
            justify-content: space-between;
          }
        }

        .calc-form-container {
          display: flex;
          width: 100%;
          justify-content: space-around;
          margin: 70px auto 0;

          .left-item {
            width: 30%;
            text-align: center;
          }

          .right-item {
            width: 30%;
            text-align: center;
          }

          .center-item {
            width: 30%;
            text-align: center;
            margin-top: 15%;

            img {
              width: 100%;
              max-width: 300px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1000px) {
  .el-form {
    .el-form-item {
      margin-top: 20px;

      /deep/ .el-form-item__label {
        font-size: 14px;
        color: #fff;
        text-align: center;
      }

      /deep/ .el-input__inner {
        height: 40px;
        font-size: 20px;
      }

      /deep/ .el-form-item__content {
        line-height: 20px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        height: 50px;
        line-height: 50px;
        font-size: 30px;
        width: 250px;
      }

      /deep/ .el-input.is-disabled.show-result .el-input__inner {
        width: 300px;
        height: 40px;
        font-size: 14px;
        margin-top: 10px;
      }
    }
  }

  .new-container {
    .container {
      width: 100%;

      .main {
        .list-container {
          width: 90%;

          .left-container {
            padding: 10px;
          }

          .content-container {
            width: 100%;
            flex-direction: column;

            .left-container, .right-container {
              width: 100%;
            }

            .content {
              margin-top: 10px;
            }
          }

          .content-container2 {
            flex-direction: column;
          }

          .title {
            margin-bottom: 30px;
          }

          .calc-form-container {
            flex-direction: row;
            align-items: center;
            width: 100%;
            position: relative;
            margin-top: 130px;

            .left-item {
              width: 100%;
            }

            .right-item {
              width: 100%;
            }

            .center-item {
              width: 70%;
              position: absolute;
              top: -160px;
              left: 50%;
              transform: translateX(-50%);
            }
          }

          .battery-container {
            flex-direction: column;

            .left {
              width: 100%;
            }

            .right {
              width: 100%;
              margin-top: 30px;

              .right-container {
                flex-direction: column;

                .right-item {
                  margin-top: 20px;

                  &:nth-child(1) {
                    width: 100%;
                  }

                  &:nth-child(2) {
                    width: 100%;
                  }

                  &:nth-child(3) {
                    width: 100%;
                  }
                }
              }
            }
          }
        }
      }

      .top {
        a {
          width: 25%;
        }
      }
    }
  }
}

@media (min-width: 1600px) {
  .new-container {
    .container {
      width: 100%;

      .main {
        .list-container {
          .content-container {
            width: 70%;
          }
        }
      }
    }
  }
}
</style>

<script>
// import qs from 'qs'
import Header from '@/components/Header'

export default {
  components: {
    Header
  },
  data() {
    return {
      loading: false,
      result: '',
      result2: '',
      show_result: '',
      show_result2: 'Pulley center distance',
      tooth_profile_options: [
        {
          value: 3,
          label: '3M'
        },
        {
          value: 5,
          label: '5M'
        }
      ],
      // 表单绑定对象
      submitForm: {
        tooth_profile: 3,
        driving_gear: 40,
        passive_gear: 15,
        central_moment: 60
      },
      submitForm2: {
        tooth_profile: 3,
        driving_gear: 40,
        passive_gear: 15,
        central_moment: 60,
        belt_length: 205
      },
      submitFormRules: {
        tooth_profile: [
          {
            required: true,
            message: '齿形必填',
            trigger: 'blur'
          }
        ],
        driving_gear: [
          {
            required: true,
            message: '主动齿轮必填',
            trigger: 'blur'
          }
        ],
        passive_gear: [
          {
            required: true,
            message: '被动齿轮必填',
            trigger: 'blur'
          }
        ],
        central_moment: [
          {
            required: true,
            message: '中心距必填',
            trigger: 'blur'
          }
        ]

      },
      submitForm2Rules: {
        tooth_profile: [
          {
            required: true,
            message: '齿形必填',
            trigger: 'blur'
          }
        ],
        driving_gear: [
          {
            required: true,
            message: '主动齿轮必填',
            trigger: 'blur'
          }
        ],
        passive_gear: [
          {
            required: true,
            message: '被动齿轮必填',
            trigger: 'blur'
          }
        ],
        belt_length: [
          {
            required: true,
            message: '皮带必填',
            trigger: 'blur'
          }
        ]

      },
      submitted: false,
      code: ''
    }
  },
  watch: {
    submitForm: {
      handler(newVal) {
        console.log(newVal)
        this.submitForm.driving_gear = parseInt(Number(newVal.driving_gear))
        this.submitForm.tooth_profile = parseInt(Number(newVal.tooth_profile))
        this.submitForm.passive_gear = parseInt(Number(newVal.passive_gear))
        this.submitForm.central_moment = Number(newVal.central_moment)
        this.calc()
      },
      deep: true,
      immediate: true
    },
    submitForm2: {
      handler(newVal) {
        console.log(newVal)
        this.submitForm2.driving_gear = parseInt(Number(newVal.driving_gear))
        this.submitForm2.tooth_profile = parseInt(Number(newVal.tooth_profile))
        this.submitForm2.passive_gear = parseInt(Number(newVal.passive_gear))
        this.submitForm2.belt_length = parseInt(Number(newVal.belt_length))
        this.calc2()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.calc()
  },
  methods: {
    numberToZeroOrFive(num) {
      const temp = parseInt(num)
      const mode = temp % 10
      let temp2 = 0
      if (mode < 5) {
        temp2 = 5 - mode
        if (temp2 < 3) {
          return temp2 + temp
        } else {
          return temp - mode
        }
      } else {
        temp2 = mode - 5
        if (temp2 < 3) {
          return temp - temp2
        } else {
          return 5 - temp2 + temp
        }
      }
    },
    submitFormChanged(cur, old) {
      console.log(cur, old)
    },
    calc() {
      this.result = (2 * this.submitForm.central_moment + (this.submitForm.driving_gear + this.submitForm.passive_gear) * this.submitForm.tooth_profile / 2 + Math.pow((this.submitForm.driving_gear - this.submitForm.passive_gear) * this.submitForm.tooth_profile / Math.PI, 2) / (4 * this.submitForm.central_moment)).toFixed(4) + ' mm'
      // eslint-disable-next-line camelcase
      const temp_result = (2 * this.submitForm.central_moment + (this.submitForm.driving_gear + this.submitForm.passive_gear) * this.submitForm.tooth_profile / 2 + Math.pow((this.submitForm.driving_gear - this.submitForm.passive_gear) * this.submitForm.tooth_profile / Math.PI, 2) / (4 * this.submitForm.central_moment)).toFixed(0)
      // eslint-disable-next-line camelcase
      this.show_result = 'Recommend Belt: HTD - ' + this.submitForm.tooth_profile + 'M - ' + this.numberToZeroOrFive(temp_result)
    },
    calc2() {
      const A = this.submitForm2.belt_length - ((this.submitForm2.driving_gear + this.submitForm2.passive_gear) * this.submitForm2.tooth_profile / 2)
      console.log('A', A)
      const X = Math.pow((this.submitForm2.driving_gear - this.submitForm2.passive_gear) * this.submitForm2.tooth_profile / Math.PI, 2)
      console.log('X', X)
      this.result2 = (((4 * A) + Math.sqrt((Math.pow(4 * A, 2)) - 32 * X)) / 16).toFixed(2) + ' mm'
    }
  }
}
</script>
